import Vue from "vue";
import VueProgressBar from "vue-progressbar";

const options = {};

Vue.use(VueProgressBar, options);
